import { IArena, ICourt, ISeat, IUnavailableSeat } from "../TableCourts/types";
import { setSelctedSeats } from "@/redux/rent/slice";
import styles from "./SeatsCell.module.scss";
import { SeatsCellPropsType } from "./type";
import { SeatItem } from "@/components/Seat";
import { ISelctedSeat } from "@/redux/rent/types";
import { recalculateDiscountsForDay } from "@/utils/courtRent/discounts";
import { moscowNow } from "@/utils/date/moscowNow";

export const SeatsCell = ({
  dispatch,
  gruntsAvailable,
  grunt_id,
  date,
  arenasTemp,
  renderSeatTime,
  onSeatSelect
}: SeatsCellPropsType) => {
  function isCellOccupiedByOthers(courtId: string, slotDate: string, time: string): boolean {
    for (const arena of arenasTemp) {
      const court = arena.courts.find((c: ICourt) => (c as any).courtId === courtId);
      if (!court) continue;

      const seat = arena.seats.find(
        (s: ISeat) => s.court_id === court.id && s.time === time
      );

      if (seat) {
        const busy = (seat as any).busy || false;
        const busyWithYou = (seat as any).busyWithYou || false;
        return busy && !busyWithYou;
      }
    }
    return false;
  }

  function changeSelectedSeat(newSelectedSeats: { [key: string]: ISelctedSeat }, clickedData?: any) {
    const updatedSeats = recalculateDiscountsForDay(
      newSelectedSeats,
      date,
      isCellOccupiedByOthers
    );
    dispatch(setSelctedSeats(updatedSeats));
    
    if (onSeatSelect && clickedData) {
      onSeatSelect(clickedData);
    }
  }

  function seatUnAvailable(
    unAvailableSeats: IUnavailableSeat,
    courtId: number,
    seatId: number
  ) {
    const courtUnAvailableSeats = unAvailableSeats[courtId];
    if (courtUnAvailableSeats) return courtUnAvailableSeats.includes(seatId);
  }

  function seatTimesUp(seatTime: string) {
    const currentDay = new Date(Date.parse(date)).getDate();
    const now = moscowNow();
    const nowDay = now.getDate();

    if (currentDay !== nowDay) return false;

    const seatHour = +seatTime.substring(0, 2);
    const currentHour = now.getHours();
    const currentMinutes = now.getMinutes();

    // Прошлые часы — всегда заблокированы
    if (seatHour < currentHour) return true;
    // Текущий час — доступен только первые 30 минут
    if (seatHour === currentHour) return currentMinutes >= 30;
    // Будущие часы — доступны
    return false;
  }
  
  return (
    <tr>
      {arenasTemp.map((arena: IArena) => {
        const courtsId = arena.courts.map((court: ICourt) => court.id);

        const validSeats = arena.seats.filter((seat: ISeat) =>
          courtsId.includes(seat.court_id)
        );

        return (
          <td key={arena.id} className={styles.seets}>
            <div className={styles.court_title_flex}>
              {validSeats.map((seat: ISeat) => {
                if (renderSeatTime !== seat.time) return;
                const timesUpThisSeat = seatTimesUp(seat.time);
                const unAvailableThisSeat = seatUnAvailable(
                  arena.unAvailableSeats,
                  seat.court_id,
                  seat.id
                );

                const currentCourt = arena.courts.find(
                  (court: ICourt) => court.id === seat.court_id
                );

                const bitrixCourtId = (currentCourt as any)?.courtId;

                if (renderSeatTime === seat.time) {
                  const busy = (seat as any).busy || false;
                  const busyWithYou = (seat as any).busyWithYou || false;
                  
                  const seatData = {
                    arenaTitle: arena.title,
                    arenaId: arena.id,
                    courtTitle: currentCourt?.title,
                    courtId: currentCourt?.id,
                    court_id: currentCourt?.id,
                    id: seat.id,
                    date: date,
                    time: seat.time,
                    price: seat.price,
                    price_weekend: seat.price_weekend,
                    is_special_price: seat.is_special_price,
                    startTimeCourt: "",
                    grunt: gruntsAvailable,
                    grunt_reserve_id: grunt_id,
                    bitrixCourtId: bitrixCourtId,
                    busy: busy,
                    busyWithYou: busyWithYou,
                  };

                  const handleSeatClick = (newSelectedSeats: { [key: string]: ISelctedSeat }, clickedTime?: string | null) => {
                    changeSelectedSeat(newSelectedSeats, {
                      time: seat.time,
                      courtType: arena.title,
                      bitrixCourtId: bitrixCourtId,
                    });
                  };

                  return (
                    <div key={seat.id} className={styles.seet}>
                      <SeatItem
                        data={seatData}
                        onClickFunc={handleSeatClick}
                        disabled={timesUpThisSeat || unAvailableThisSeat}
                      />
                    </div>
                  );
                }
              })}
            </div>
          </td>
        );
      })}
    </tr>
  )
}